
import { VendorPayment } from './VendorPayment';
export class VendorDocument {
  public InvoiceDate: Date;
  public InvoiceType: string;
  public InvoiceNumber: string;
  public EncryptedInvNumber: string;
  public WorkOrder: string;
  public PONumber: string;
  public Amount: number;
  public Status: string;
  public filterStatus:string
  public TechRepNotes: string;
  public Source: string;
  public InvoicePath: string;
  public Currency: string;
  public ExternalDocumentNumber: string;
  public DocumentType: string;
  public TotalAmount: number;
  public AppliedAmount: number;
  public UserName: string;
  public RegNumber: string;
  public payments: VendorPayment[];
  public PONumberList: string[];
  public File: number[];
  public FileName: string;
  public FileData: string;
  public GPVID: string;
}



// WEBPACK FOOTER //
// ./src/app/models/VendorDocument.ts